import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import BryxDropdown from "../BryxDropdown";
import BryxColors from "../../types/theme";
const BryxPageSizeDropdown = styled((props) => (_jsx(BryxDropdown, { ...props, hideLabel: true, disableUnselect: true, noBorder: true, iconViewbox: "0 0 8 6" })))(({ theme }) => ({
    height: "26px !important",
    width: "55px",
    border: "none",
    "&:hover": {
        "& *": {
            // color: BryxColors.brand1(theme.palette.mode) + " !important",
            fill: BryxColors.brand1(theme.palette.mode) + " !important",
        },
    },
    "& .MuiSelect-select": {
        paddingRight: "0px !important",
        paddingLeft: "8px",
        fontSize: "13px",
    },
    svg: {
        width: "8px",
        height: "5px",
        right: "10px !important",
    },
}));
export default BryxPageSizeDropdown;
